export const en = {
  add_a_circle: 'Add a circle',
  add_a_free_hand_shape: 'Add a free hand shape',
  add_a_line: 'Add a line',
  add_a_rectangle: 'Add a rectangle',
  add_an_arrow_shape: 'Add an arrow shape',
  add_an_ellipse: 'Add an ellipse',
  add_image_from_url: 'Add image from URL',
  anonymous: 'Anonymous',
  arrow: 'Arrow',
  border_color: 'Border color',
  cancel: 'Cancel',
  circle: 'Circle',
  click_on_canvas_to_write: ' Click on canvas to write text',
  click_to_delete_shape: 'Click on shape to delete it',
  container_size: 'Container Size',
  create_annotation: 'Create annotation',
  createdByOn: 'Created by {{creator}}, {{creationDate}}',
  debugAnnotation: 'Debug annotation in console',
  delete: 'Delete',
  delete_all: 'Delete all',
  deleteAnnotation: 'Delete',
  detected_media_type: 'We detect {{mediaType}} media type.',
  document: 'Document',
  drawings_and_text_in_overlay: 'Drawings and text in overlay',
  edit: 'Edit',
  edit_annotation: 'Edit annotation',
  edit_iiif_json_code: 'Edit directly the IIIF json code',
  ellipse: 'Ellipse',
  expert_mode: 'Expert mode',
  export_annotation: 'Export Annotations',
  export_annotation_for: 'Export annotation for {{label}}',
  export_local_annotation: 'Export local annotations for visible items',
  fill_color: 'Fill color',
  freehand: 'Freehand',
  image: 'Image',
  image_displayed: 'Image Displayed',
  image_in_overlay_with_note: 'Image in overlay with a note',
  image_true_size: 'Image True Size',
  imageUrl: 'Image URL',
  invalid_url: 'Invalid URL',
  lastEditedByOn: 'Last edit by {{lastEditor}}, {{lastSavedDate}}',
  line: 'Line',
  line_weight: 'Line weight',
  loading_failed: 'Loading failed',
  maev_github_link: 'https://github.com/SCENE-CE/mirador-annotation-editor-video',
  manifest_link: 'Manifest annotation',
  manifest_link_with_note: 'Manifest with note',
  manifest_url: 'Manifest URL',
  media_not_supported: 'Media not supported',
  media_not_supported_text: 'The media you try to annotate is not supported by this instance at the moment',
  metadata: 'Metadata',
  new_annotation: 'New annotation',
  no_annotation: 'No annotations stored yet.',
  note: 'Note',
  object_list: 'Object list',
  onlyOneImageAllowed: 'Only one image is allowed',
  overlay: 'Overlay',
  polygon: 'Polygon',
  pressEnterToAddTag: 'Add your tag and press "Enter"',
  pressEscapeToFinish: 'Press "Esc" to finish the line',
  rectangle: 'Rectangle',
  save: 'Save',
  scale: 'Scale',
  select_cursor: 'Select Cursor',
  selected_object: 'Selected object',
  shape: 'Shape',
  shape_selection: 'Draw shapes',
  shapes: 'Shapes',
  spatialTarget: 'Shapes',
  style: 'Style',
  style_selection: 'Style selection',
  switch_view: 'Switch to single view',
  switch_view_content: 'Annotations can only be edited in single canvas view type.\n'
    + 'Switch view type to single view now?',
  switch_view_h2: 'Switch view type to single view?',
  tag: 'Tag',
  tags: 'Tags',
  tagsPlaceholder: 'Add tags ...',
  tag_with_target: 'Tag with target',
  target: 'Target',
  text: 'Text',
  textual_note_with_target: 'Textual note with target',
  tool_selection: 'Tool Selection',
  unsupported_media_message: 'Your current canvas media type is not supported by the annotation editor.',
  useTemplate: 'Use a template',
  video_annotation_instruction: 'If you want to annotate video media, you must install MAEV to create and edit annotations on video:',
  your_tag_here: 'Your tag here:',
  zoom: 'Zoom',
};
